import { useEffect, useRef, useState } from "react";

export function QuizImage({ image, testId = "quiz-question-image" }) {
  const [state, setState] = useState("loading");
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current?.complete && ref.current.naturalWidth) setState("ready");
  }, []);
  if (!image || state === "error") return null;
  return (
    <figure className="relative mb-6 w-full aspect-[3/2] max-h-[38vh] rounded-2xl overflow-hidden border border-[#1F1F23] bg-[#1A1A1D]" data-testid={testId}>
      {state === "loading" && <div className="absolute inset-0 animate-pulse bg-[#141416]" />}
      <img
        ref={ref}
        src={image.src}
        alt={image.alt}
        loading="eager"
        decoding="async"
        onLoad={() => setState("ready")}
        onError={() => setState("error")}
        className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-200 ${state === "ready" ? "opacity-100" : "opacity-0"}`}
      />
    </figure>
  );
}

export const preloadImage = (image) => {
  if (image?.src) new Image().src = image.src;
};

export async function cacheQuizImages(questions) {
  if (!("caches" in window)) return;
  const srcs = [...new Set(questions.map((q) => q.image?.src).filter(Boolean))];
  if (!srcs.length) return;
  const cache = await caches.open("rollsmartr-runtime-v2");
  await Promise.all(srcs.map(async (src) => { if (!(await cache.match(src))) await cache.add(src).catch(() => {}); }));
}
